import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPostBySlug } from '../../actions/postActions';
import Spinner from '../common/Spinner/Spinner';
import Post from './Post';


class PostContainer extends Component {
  static propTypes = {
    post: PropTypes.object.isRequired,
    getPostBySlug: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.props.getPostBySlug(this.props.match.params.slug);
  }

  render() {
    const { post } = this.props;

    if (Object.keys(post).length === 0 || post.slug !== this.props.match.params.slug) {
      return <Spinner style={{ marginTop: '200px', marginBottom: '200px' }} />;
    } else {
      return (
        <Post
          title={post.title}
          image={post.image}
          date={post.date}
          slug={post.slug}
          content={post.content}
        />
      );
    }
  }
}


const mapStateToProps = (state) => ({
  post: state.posts.single,
  fetching: state.posts.fetching
});

const mapDispatchToProps = {
  getPostBySlug
};

export default connect(mapStateToProps, mapDispatchToProps)(PostContainer);



// WEBPACK FOOTER //
// ./src/components/Posts/PostContainer.js